import type { IDayWorkHour } from "@/interfaces/IDayWorkHour";
import { CrudState } from "@/store/Crud/State";

export class State extends CrudState {}
